import { PageDatagridToolbarActionComponent } from "./page-datagrid/page-datagrid-toolbar-action.component";
import DevExpress from "devextreme";
import { compact } from "lodash-es";
import { PageGenericActionComponent } from "./page-generic/page-generic-action.component";
import { EventEmitter, InputSignal, OutputEmitterRef } from "@angular/core";
import { ButtonClickAsyncEvent } from "src/app/components/ui/button/button-click-async-event";
import DataSource from "devextreme/data/data_source";

function getDisabledStatusByDisableBySelection(
  selectedKeys: any[] = [],
  action: PageDatagridToolbarActionComponent | PageGenericActionComponent
): boolean {
  const config: { single: boolean; multiple: boolean; limit?: number } | null =
    (<PageDatagridToolbarActionComponent>action).enableBySelection || null;

  if (!config) {
    return false;
  }

  if (!!config.limit && selectedKeys.length > config.limit) {
    return false;
  }

  switch (selectedKeys.length) {
    case 0: {
      if (config.single) {
        return true;
      }
      if (config.multiple) {
        return true;
      }
      return true;
    }
    case 1: {
      if (config.single) {
        return false;
      }
      if (config.multiple) {
        return true;
      }
      return true;
    }
    default: {
      if (!config.multiple) {
        return true;
      }
      if (config.single) {
        return true;
      }

      return false;
    }
  }
}

export function mapDxToolbarItems({
  actionItems,
  textItems,
  selectItems,
  selectedKeys = []
}: {
  actionItems: Array<{
    icon: string;
    title: string;
    disabled: boolean;
    onClick: EventEmitter<void>;
    onClickAsync: EventEmitter<ButtonClickAsyncEvent>;
  }>;
  textItems?: Array<{
    component: string;
    placeholder: InputSignal<string>;
    classList: InputSignal<string>;
    hidden: InputSignal<boolean>;
    disabled: InputSignal<boolean>;
    emitTextComponentRef: OutputEmitterRef<any>;
    onValueChanged: OutputEmitterRef<any>;
  }>;
  selectItems?: Array<{
    component: string;
    placeholder: InputSignal<string>;
    classList: InputSignal<string>;
    hidden: InputSignal<boolean>;
    dataSource: InputSignal<DataSource>;
    onValueChanged: OutputEmitterRef<any>;
  }>;
  selectedKeys?: any[];
}): DevExpress.ui.dxToolbarItem[] {
  const actions = [
    ...actionItems.map((x) => {
      return <DevExpress.ui.dxToolbarItem>{
        widget: "dxButton",
        location: "before",
        options: {
          icon: x.icon,
          hint: x.title,
          stylingMode: "contained",
          elementAttr: {
            class: "shadow-sm rounded-full"
          },
          disabled:
            x.disabled ||
            getDisabledStatusByDisableBySelection(selectedKeys, x),
          onClick: () => {
            x.onClick?.emit(<any>selectedKeys);
          },
          onClickAsync: () => {}
        }
      };
    })
  ];
  const texts = [
    ...(textItems ?? [])
      .filter((x) => !x.hidden())
      .map((x) => {
        return <DevExpress.ui.dxToolbarItem>{
          widget: x.component,
          location: "before",
          options: {
            elementAttr: {
              class: x.classList()
            },
            disabled: x.disabled(),
            valueChangeEvent: "input",
            showClearButton: true,
            placeholder: x.placeholder(),
            onValueChanged: (event: any) => {
              x.onValueChanged.emit(event);
            },
            onInitialized: (e: any) => {
              x.emitTextComponentRef.emit(e.component);
            }
          }
        };
      })
  ];
  const selects = [
    ...(selectItems ?? [])
      .filter((x) => !x.hidden())
      .map((x) => {
        return <DevExpress.ui.dxToolbarItem>{
          widget: x.component,
          location: "before",
          options: {
            displayExpr: "display",
            valueExpr: "value",
            elementAttr: {
              class: x.classList()
            },
            showClearButton: true,
            searchEnabled: true,
            placeholder: x.placeholder(),
            dataSource: x.dataSource(),
            onValueChanged: (event: any) => {
              x.onValueChanged.emit(event);
            }
          }
        };
      })
  ];
  return compact<DevExpress.ui.dxToolbarItem>([
    ...actions,
    ...texts,
    ...selects,
    selectedKeys.length > 0
      ? <DevExpress.ui.dxToolbarItem>{
          text:
            selectedKeys.length === 1
              ? "Selezionata una riga"
              : `${selectedKeys.length} righe selezionate`,
          location: "after"
        }
      : null
  ]);
}
